import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import { BaseModalRef } from "components/BaseModal";
import BaseModalForm from "components/BaseModalForm";
import { FindingBucketContextType } from "contexts/FindingBucketContext";
import { noop } from "lodash";
import React, { ReactNode, forwardRef } from "react";
import { Fields } from "types/fields";
import { FieldTypes, checkCharLimit } from "utils/formUtils";

type Props = {
  afterClose: () => void;
  fields: Fields;
  bucket?: FindingBucketContextType;
  title: string | JSX.Element;
  modalProps: any; // @TODO - fix ts
  onOk: (formData: any) => Promise<void>;
  setFindingCount?: (count: number) => void;
  form: FormInstance;
  initialValues?: {};
  children?: ReactNode;
};

const BulkUpdatePopup = forwardRef<BaseModalRef, Props>(
  (
    {
      afterClose,
      bucket,
      fields,
      onOk,
      modalProps,
      title,
      form: parentForm,
      initialValues = {},
      children,
    },
    ref,
  ) => {
    const [form] = Form.useForm(parentForm);

    const { clear: clearSelection = noop } = bucket || {};

    const handleOnOk = async () => {
      await form.validateFields();

      let data = {
        ...form.getFieldsValue(),
      };

      await onOk(data);
      clearSelection();
    };

    const allFields = [
      ...fields,
      {
        name: "notes",
        label: "Note",
        type: FieldTypes.TEXT_AREA,
        required: true,
        rules: [checkCharLimit(1000)],
        NoDefaultLengthRule: true,
      },
    ];

    const _modalProps = {
      cancelBtnText: "Cancel changes",
      closable: false,
      className: "small-padding",
      ...modalProps,
    };

    return (
      <BaseModalForm
        title={title}
        onOk={handleOnOk}
        initialValues={initialValues}
        form={form}
        fields={allFields}
        modalProps={_modalProps}
        afterClose={afterClose}
        ref={ref}
      >
        {children}
      </BaseModalForm>
    );
  },
);

export default BulkUpdatePopup;
